// src/components/BoardPackConfiguration/data.jsx
export const PAGE_TYPES = [
  // Layout
  { value: "title_page", label: "Contract Title Page", category: "Layout" },
  { value: "last_title", label: "Operations Director Comments", category: "Layout" },
  // Tables
  { value: "main_table", label: "Profit & Loss", category: "Tables" },
  { value: "third_table", label: "Headline Operational Stats", category: "Tables" },
  { value: "large_table", label: "Profit & Loss With Outturn", category: "Tables" },
  { value: "kpi_enforcement_table", label: "Monthly Enforcement KPI Table", category: "Tables" },
  // Charts
  { value: "bar_chart", label: "Daily Revenue Bar Chart", category: "Charts" },
  {
    value: "kpi_chart_12",
    label: "Revenue, Transaction, ATV and ALS Bar Chart",
    category: "Charts",
  },
  { value: "kpi_chart_12_new", label: "Monthly Rental Income Bar Chart", category: "Charts" },
  {
    value: "new_chart_kpi",
    label: "Average Revenue, Parking Bays, Transactions, Occupancy Bar Chart",
    category: "Charts",
  },
  {
    value: "kpi_chart_new",
    label: "Monthly Rental Income v Actual v Prior Year v Budget Bar Chart",
    category: "Charts",
  },
  {
    value: "new_stack_chart",
    label: "Transaction by Payment Source Bar Chart",
    category: "Charts",
  },
  { value: "line_bars", label: "On-Street Performance - KPI Bar Chart", category: "Charts" },
  {
    value: "line_bars_table",
    label: "On-Street Performance - KPI Bar Chart With Table",
    category: "Charts",
  },
  { value: "donut_chart_18", label: "Donut Chart", category: "Charts" },
  { value: "donut_chart", label: "Donut Chart Dynamic", category: "Charts" },
  { value: "area_chart", label: "Area Chart", category: "Charts" },
  { value: "kpi_chart_13", label: "Occupancy Chart", category: "Charts" },
  { value: "kpi_chart_14", label: "Occupancy by Duration", category: "Charts" },
  { value: "new_chart_component", label: "KPI Transactions", category: "Charts" },
  { value: "Dotted_Line_Chart", label: "MTP Transactions all Years", category: "Charts" },
  // Profiles
  // { value: "jeddah_profile_summary02", label: "Jeddah Airport Profile (Pg 2)", category: "Profiles" },
  // { value: "jeddah_profile_summary10", label: "Jeddah Airport Profile (Pg 10)", category: "Profiles" },
  // { value: "jeddah_profile_summary_arabic", label: "Jeddah Airport Enforcement Profile", category: "Profiles" },
  // { value: "jeddah_on_street_profile", label: "Jeddah On-Street Profile", category: "Profiles" },
  // { value: "jeddah_off_street_profile", label: "Jeddah Off-Street Profile", category: "Profiles" },
  // { value: "sharjha_profile_table", label: "Sharjah Airport Parking Profile", category: "Profiles" },
  // { value: "profile_summary_airport_jordan", label: "Jordan Airport Profile", category: "Profiles" },
  // { value: "profile_summary_lovers_market", label: "Lovers Market Profile", category: "Profiles" },
  // { value: "profile_summary_AlBatha_4", label: "Al Batha Profile (Pg 4)", category: "Profiles" },
  // { value: "profile_summary_AlBatha_11", label: "Al Batha Profile (Pg 11)", category: "Profiles" },
  // { value: "profile_summary_dammam", label: "Dammam Airport Profile", category: "Profiles" },
  // { value: "profile_summary_bilal", label: "Bilal Profile", category: "Profiles" },
  // { value: "profile_summary_BabAlRee_4", label: "Bab Al-Ree Profile (Pg 4)", category: "Profiles" },
  // { value: "profile_summary_BabAlRee_11", label: "Bab Al-Ree Profile (Pg 11)", category: "Profiles" },
  // { value: "Gazzaz_4", label: "Gazzaz Profile (Pg 4)", category: "Profiles" },
  // { value: "Gazzaz_11", label: "Gazzaz Profile (Pg 11)", category: "Profiles" },
  // { value: "JedWatch_4", label: "Jed Watch Profile (Pg 4)", category: "Profiles" },
  // { value: "JedWatch_11", label: "Jed Watch Profile (Pg 11)", category: "Profiles" },
  // { value: "total_dubai_airport_profile", label: "Total Dubai Airport Profile", category: "Profiles" },
  // { value: "dubai_airport_t1_profile", label: "Dubai Airport T1 Profile", category: "Profiles" },
  // { value: "dubai_airport_t2_profile", label: "Dubai Airport T2 Profile", category: "Profiles" },
  // { value: "dubai_airport_t3_profile", label: "Dubai Airport T3 Profile", category: "Profiles" },
  // { value: "dubai_airport_cargo_profile", label: "Dubai Airport Cargo Profile", category: "Profiles" },
  // { value: "madinah_haram_profile", label: "Madinah Haram Profile", category: "Profiles" },
  // { value: "madinah_haram_parking_profile", label: "Madinah Haram Parking Profile", category: "Profiles" },
  // { value: "madinah_haram_enforcement_profile", label: "Madinah Haram Enforcement Profile", category: "Profiles" },
  // { value: "taif_on_street_profile", label: "Taif On-Street Profile", category: "Profiles" },
  // { value: "taif_off_street_profile", label: "Taif Off-Street Profile", category: "Profiles" },
  // { value: "khamis_on_street_profile", label: "Khamis On-Street Profile", category: "Profiles" },
  // { value: "khamis_off_street_profile", label: "Khamis Off-Street Profile", category: "Profiles" },
  // { value: "jubail_on_street_profile", label: "Jubail On-Street Profile", category: "Profiles" },
  // { value: "alhassa_on_street_profile", label: "Al Hassa On-Street Profile", category: "Profiles" },
  // { value: "mawgif_jeddah_on_street_profile", label: "Mawgif Jeddah On-Street Profile", category: "Profiles" },
  // { value: "digital_city_on_street_profile", label: "Digital City On-Street Profile", category: "Profiles" },
  // { value: "digital_city_off_street_profile", label: "Digital City Off-Street Profile", category: "Profiles" },
  // { value: "albaha_on_street_profile", label: "Al Baha On-Street Profile", category: "Profiles" },
  // { value: "albaha_off_street_profile", label: "Al Baha Off-Street Profile", category: "Profiles" },
  // { value: "dammam_causeway_on_street_profile", label: "Dammam Causeway On-Street Profile", category: "Profiles" },
  // { value: "dammam_causeway_off_street_profile", label: "Dammam Causeway Off-Street Profile", category: "Profiles" },
  // { value: "baljurashi_on_street_profile", label: "Baljurashi On-Street Profile", category: "Profiles" },
  // { value: "baljurashi_off_street_profile", label: "Baljurashi Off-Street Profile", category: "Profiles" },
  // { value: "makkah_on_street_profile", label: "Makkah On-Street Profile", category: "Profiles" },
  // { value: "makkah_off_street_profile", label: "Makkah Off-Street Profile", category: "Profiles" },
  // { value: "makkah_misfalah_profile", label: "Makkah Misfalah Profile", category: "Profiles" },
  // { value: "makkah_jarwal_profile", label: "Makkah Jarwal Profile", category: "Profiles" },
  // { value: "moc_on_street_profile", label: "MOC On-Street Profile", category: "Profiles" },
];
export const CATEGORY_COLORS = {
  Layout: "bg-purple-100 text-purple-700 border-purple-200",
  Tables: "bg-blue-100   text-blue-700   border-blue-200",
  Charts: "bg-orange-100 text-orange-700 border-orange-200",
  Profiles: "bg-green-100  text-green-700  border-green-200",
};
export const CATEGORY_DOT = {
  Layout: "bg-purple-400",
  Tables: "bg-blue-400",
  Charts: "bg-orange-400",
  Profiles: "bg-green-400",
};
export const PAGE_TYPE_MAP = Object.fromEntries(PAGE_TYPES.map((p) => [p.value, p]));
export const DEFAULT_PARAMS = {
  // data.js — DEFAULT_PARAMS
  title_page: {
    contract: "",
    showDate: true,
    showNote: true,
    notes:
      "Numbers have been rounded up to the nearest value and thus there may be rounding errors when comparing the variances", // ✅ default text
    sub_contracts: [],
  },
  last_title: { title: "Operations Director Comments" },
  main_table: {
    api: "/board-pack/page-one",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      measure: 0,
      currency: "Local Currency",
    },
    showTitle: true,
    showSubtitle: true,
    subtitle: "Local Currency",
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} - Profit & Loss Current Month / YTD / Year`
        : "Profit & Loss Current Month / YTD / Year";
    },
  },
  third_table: {
    api: "/boardpack/enforcement-monthly-kpi",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      value_type: 2,
      is_cfo: true,
      get ai_contract_name() {
        const contract = localStorage.getItem("selectedContract");
        return contract;
      },
    },
    showTitle: true,
    title: "CFO Comments",
    get headerTitle() {
      const contract = localStorage.getItem("selectedContract");
      return contract;
    },
    subheaderTitle: "TOWS",
    get first_heading() {
      const contract = localStorage.getItem("selectedContract");
      return contract;
    },
    second_heading_Bold:
      "Enforcement Headline Operational Stats - Actual V Prior Month V Budget V Prior Year",
    third_hedaing: "TOWS",
  },
  large_table: {
    api: "/board-pack/page-one",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      measure: 2,
      currency: "Local Currency",
      is_cfo: true,
      get ai_contract_name() {
        const contract = localStorage.getItem("selectedContract");
        return contract;
      },
    },
    showTitle: true,
    showSubtitle: true,
    title: "CFO Comments",
    get subtitle() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} - Profit and Loss - Current Month / YTD / Full Year`
        : "Profit and Loss - Current Month / YTD / Full Year";
    },
  },
  kpi_enforcement_table: {
    api: "/boardpack/enforcement-monthly-kpi",
    params: { contract: "", year: "{{year}}", month: "{{month}}", value_type: 1 },
    showTitle: true,
    showSubtitle: true,
    subtitle: "Monthly Enforcement - KPI",
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} Enforcement Performance - KPI`
        : "Enforcement Performance - KPI";
    },
  },
  bar_chart: {
    api: "/board-pack/parking-enforcement",
    params: { contract: "", year: "{{year}}", month: "{{month}}", version: "Actual" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Performance - KPI` : "Enforcement Performance - KPI";
    },
    subtitle: "Daily Revenue Actual (Including Friday's) - Parking + Enforcement",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} (INCLUDING FRIDAYS)` : "(INCLUDING FRIDAYS)";
    },
    datasetsConfig: [
      {
        type: "bar",
        label: "Enforcement",
        dataKey: "enforcement",
        color: "#5B9BD5",
      },
      {
        type: "bar",
        label: "Parking",
        dataKey: "parking",
        color: "#ED7D31",
      },
      {
        type: "line",
        label: "Enf Avg",
        dataKey: "enforcementAvg",
        color: "#5B9BD5",
        borderDash: [4, 4],
      },
      {
        type: "line",
        label: "Park Avg",
        dataKey: "parkingAvg",
        color: "#ED7D31",
        borderDash: [4, 4],
      },
    ],
    tableConfig: [
      {
        label: "Enforcement",
        dataKey: "enforcement",
        color: "#5B9BD5",
      },
      {
        label: "Parking",
        dataKey: "parking",
        color: "#ED7D31",
      },
    ],
    LEGEND_CONFIG: {
      enforcement: {
        label: "Enforcement",
      },
      parking: {
        label: "Parking",
      },
      enforcementAvg: {
        label: "2 per. Mov. Avg. (Enforcement)",
      },
      parkingAvg: {
        label: "2 per. Mov. Avg. (Parking)",
      },
    },
  },
  kpi_chart_12: {
    api: "/board-pack/page-twelve",
    params: { contract: "", year: "{{year}}", month: "{{month}}", kpi: "revenue" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Parking Performance KPI` : "Parking Performance KPI";
    },
    subtitle: "Revenue, Transaction, ATV and ALS",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract}` : "";
    },
    showDataLabels: true,
    colors: {
      revenue: "#4C96D9",
      transaction: "#ff9933",
      atv: "#808080",
      als: "#ffd700",
    },
    labels: {
      revenue: "Monthly Revenue",
      transaction: "Monthly Transaction",
      atv: "ATV",
      als: "ALS",
    },
    yAxisFormatters: {
      left: true,
      right: true,
    },
  },
  kpi_chart_12_new: {
    api: "/board-pack/real-estate-kpi",
    params: { contract: "", year: "{{year}}", month: "{{month}}", value_type: "1" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Real Estate - KPI` : "Real Estate - KPI";
    },
    subtitle: "Monthly Rental Income Profile",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} - REAL ESTATE Monthly Rental Income Profile`
        : "REAL ESTATE Monthly Rental Income Profile";
    },
    showDataLabels: true,
    colors: {
      revenue: "#00d4ff",
      transaction: "#C90A0A",
      atv: "#808080",
      als: "#ffd700",
    },
    labels: {
      revenue: "Revenue",
      transaction: "Units Rented",
      atv: "Price per Sq Mtr",
      als: "Occupancy%",
    },
    yAxisFormatters: {
      left: true,
      right: true,
    },
  },
  new_chart_kpi: {
    api: "/board-pack/page-twelve",
    params: { contract: "", year: "{{year}}", month: "{{month}}", kpi: "on_street" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} On-Street Performance - KPI` : "On-Street Performance - KPI";
    },
    subtitle: "Average Revenue, Parking Bays, Transactions, Occupancy",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} ON STREET` : "ON STREET";
    },
    yAxisLabel: "On Street Parking",
    bottomLabel: "Months",
    showDataLabels: true,
    colors: {
      revenue: "#4C96D9",
      transaction: "#ff9933",
      atv: "#C00000",
      als: "#ffd700",
    },
    labels: {
      revenue: "Monthly_Avg_Daily_Parking_Revenue",
      transaction: "Total_Parking_Bays",
      atv: "Monthly_Avg_Daily_Transaction",
      als: "Parking_Occupancy",
    },
    yAxisFormatters: {
      left: true,
      right: true,
    },
  },
  kpi_chart_new: {
    api: "/board-pack/real-estate-kpi",
    params: { contract: "", year: "{{year}}", month: "{{month}}", value_type: "2" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Real Estate - KPI` : "Real Estate - KPI";
    },
    subtitle: "Monthly Rental Income v Actual v Prior Year v Budget",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} - REAL ESTATE - Actual v Prior Year v Budget v Base {{year}}`
        : "REAL ESTATE - Actual v Prior Year v Budget v Base {{year}}";
    },
  },
  new_stack_chart: {
    api: "/board-pack/real-estate-kpi",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      value_type: "1",
      device_onstreet: "JED",
    },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} On-Street Performance - KPI` : "On-Street Performance - KPI";
    },
    subtitle: "Transaction by Payment Source - APP/WEB, PND",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} ON STREET` : "ON STREET";
    },
    showDataLabels: true,
    yAxisLabel: "Ticket Count by Payment Source",
    bottomLabel: "Months",
    colors: {
      revenue: "#4C96D9",
      transaction: "#ff9933",
      atv: "#808080",
      als: "#ffd700",
    },
    labels: {
      revenue: "APP/WEB,Ticket_Count",
      transaction: "PND,Ticket_Count",
      atv: "App to Ticket_Count",
    },
    yAxisFormatters: {
      left: true,
      right: true,
    },
  },
  line_bars: {
    api: "/boardpack/enforcement-monthly-trend",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      measure: "Average Value of CN",
      data_type: "three_years",
    },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} On-Street Performance - KPI` : "On-Street Performance - KPI";
    },
    subtitle: "Average Daily Job Count",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} ON STREET Average Daily Job Count`
        : "ON STREET Average Daily Job Count";
    },
    showRamadanRow: true,
    ramadanBorderColor: "#FAFA01",
    barDatasets: [
      {
        label: "CLAMP",
        color: "rgba(180,180,180,0.6)",
      },
    ],
    datasets: [
      {
        label: "CNS",
        color: "#1787B0",
      },
      {
        label: "CLAMP",
        color: "#E17A35",
      },
      {
        label: "TOW",
        color: "#FAFA01",
      },
    ],
  },
  line_bars_table: {
    api: "/boardpack/enforcement-monthly-trend",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      measure: "Average Value of CN",
      data_type: "three_years",
    },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} On-Street Performance - KPI` : "On-Street Performance - KPI";
    },
    subtitle: "Average Daily Job Count",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} ON STREET Average Daily Job Count`
        : "ON STREET Average Daily Job Count";
    },
    showRamadanRow: true,
    ramadanBorderColor: "#E17A35",
    showSecondTable: true,
    secondTableData: "chartData.secondTableData",
    datasets: [
      {
        label: "Clamp Driver Emp",
        color: "#E17A35",
        order: 1,
        borderDash: [5, 5],
      },
      {
        label: "Clamp Driver Dep",
        color: "#E17A35",
        order: 3,
      },
    ],
    barDatasets: [
      {
        label: "",
        color: "rgba(180,180,180,0.6)",
        order: 2,
        hideInTable: true,
      },
    ],
  },
  donut_chart_18: {
    api: "/boardpack/payment-sources",
    params: { contract: "", year: "{{year}}", month: "{{month}}", value_type: 1 },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Performance - KPI` : "";
    },
    subtitle: "Revenue Split by - Type and Source",
    in_chart_content_line_1: "Revenue Payment Split by Payment Type",
    in_chart_content_line_2: "Revenue Payment Split by Payment Type and Source",
  },
  donut_chart: {
    api: "/boardpack/payment-sources",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      value_type: 1,
      device_onstreet: "JED",
    },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Performance - KPI` : "Performance - KPI";
    },
    subtitle: "Payment by Source and Type",
    in_chart_content_line_1: "Revenue Payment Split by Payment Type and Source",
    in_chart_content_line_2: "Payment in PND (CASH) split by Ewallet, Notes and Coins",
   "chart_config": {
          "first_chart": {
            "keys": [
              "pnd",
              "pndAppWeb"
            ],
            "colors": {
              "pnd": "#1D8AE9",
              "pndAppWeb": "#F26E14"
            }
          },
          "second_chart": {
            "keys": [
              "PND :: CARD",
              "PND :: COINS",
              "PND :: EWALLET",
              "PND :: NOTES"
            ],
            "colors": {
              "PND :: CARD": "#208FF3",
              "PND :: COINS": "#208FF3",
              "PND :: EWALLET": "#208FF3",
              "PND :: NOTES": "#208FF3"
            }
          }
        }
  },
  area_chart: {
    api: "/boardpack/transaction-by-duration",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      value_type: 2,
      average_calculation: "full_month",
      device_onstreet: "BHA",
    },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} On-Street Performance - KPI` : "On-Street Performance - KPI";
    },
    subtitle: "Average Daily Revenue Profile Time Graph",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract}` : "";
    },
    yAxisLabel: "MONTHLY DAILY VOLUMES"
  },
  kpi_chart_13: {
    api: "/board-pack/page-twelve",
    params: { contract: "", year: "{{year}}", month: "{{month}}", kpi: "occupancy" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Performance - KPI` : "Performance - KPI";
    },
    subtitle: "Occupancy by Year/Month",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract}` : "";
    },
  },
  kpi_chart_14: {
    api: "/boardpack/transaction-by-duration",
    params: { contract: "", year: "{{year}}", month: "{{month}}", value_type: 1 },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} Performance - KPI` : "Performance - KPI";
    },
    subtitle: "Occupancy by Year/Month",
    in_chart_content_line_1: "Parking Duration -Based on Average Monthly Transaction",
    get in_chart_content_line_2() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract}` : "";
    },
    bottomLabel: "MONTHLY AVERAGE TRANSACTION",
    yAxisLabel: "PARKING DURATION - HRS",
  },
  new_chart_component: {
    api: "/boardpack/transaction-by-duration",
    params: { contract: "", year: "{{year}}", month: "{{month}}", version: "ticket_Count" },
    showTitle: true,
    showSubtitle: true,
    get title() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} On-Street Performance - KPI` : "On-Street Performance - KPI";
    },
    subtitle: "Transactions by Year/Month",
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} ON STREET` : "ON STREET";
    },
    yAxisLabel: "Transaction",
    bottomLabel: "Months",
  },
  Dotted_Line_Chart: {
    api: "/boardpack/transaction-by-duration",
    params: {
      contract: "",
      year: "{{year}}",
      month: "{{month}}",
      measure: "4",
      currency: "Local Currency",
      is_cfo: true,
      get ai_contract_name() {
        const contract = localStorage.getItem("selectedContract");
        return contract;
      },
    },
    showTitle: true,
    showSubtitle: true,
    title: "CFO Comments",
    get subtitle() {
      const contract = localStorage.getItem("selectedContract");
      return contract ? `${contract} ` : "";
    },
    get in_chart_content_line_1() {
      const contract = localStorage.getItem("selectedContract");
      return contract
        ? `${contract} Prior Year Performance MTP - Local Currency`
        : "Prior Year Performance MTP - Local Currency";
    },
  },
};

// ─── Profile page defaults ────────────────────────────────────────────────────
const _profileDefault = {
  api: "/boardpack/get-tables-data",
  params: { contract: "", year: "{{year}}", month: "{{month}}" },
  api2: "/boardpack/parking/bays",
  params2: { contract: "", year: "{{year}}", month: "{{month}}", value: "" },
};

const PROFILE_TYPES = [
  "jeddah_profile_summary02",
  "jeddah_profile_summary10",
  "jeddah_profile_summary_arabic",
  "jeddah_on_street_profile",
  "jeddah_off_street_profile",
  "sharjha_profile_table",
  "profile_summary_airport_jordan",
  "profile_summary_lovers_market",
  "profile_summary_AlBatha_4",
  "profile_summary_AlBatha_11",
  "profile_summary_dammam",
  "profile_summary_bilal",
  "profile_summary_BabAlRee_4",
  "profile_summary_BabAlRee_11",
  "Gazzaz_4",
  "Gazzaz_11",
  "JedWatch_4",
  "JedWatch_11",
  "total_dubai_airport_profile",
  "dubai_airport_t1_profile",
  "dubai_airport_t2_profile",
  "dubai_airport_t3_profile",
  "dubai_airport_cargo_profile",
  "madinah_haram_profile",
  "madinah_haram_parking_profile",
  "madinah_haram_enforcement_profile",
  "taif_on_street_profile",
  "taif_off_street_profile",
  "khamis_on_street_profile",
  "khamis_off_street_profile",
  "jubail_on_street_profile",
  "alhassa_on_street_profile",
  "mawgif_jeddah_on_street_profile",
  "digital_city_on_street_profile",
  "digital_city_off_street_profile",
  "albaha_on_street_profile",
  "albaha_off_street_profile",
  "dammam_causeway_on_street_profile",
  "dammam_causeway_off_street_profile",
  "baljurashi_on_street_profile",
  "baljurashi_off_street_profile",
  "makkah_on_street_profile",
  "makkah_off_street_profile",
  "makkah_misfalah_profile",
  "makkah_jarwal_profile",
  "moc_on_street_profile",
];

PROFILE_TYPES.forEach((t) => {
  DEFAULT_PARAMS[t] = _profileDefault;
});
